/**
 * Sidebar Component
 *
 * Navigation sidebar with dynamic menu from database.
 * Falls back to static items when API is unavailable.
 *
 * @since 2025-12-16
 * @epic INIT-0045, INIT-0046
 */

import { DynamicSidebar } from '@/components/navigation';

/**
 * Sidebar component.
 *
 * This component now uses DynamicSidebar which loads menu items
 * from the database via Python API. It falls back to static items
 * when the API is unavailable.
 *
 * Features:
 * - Dynamic menu loading from database
 * - Hierarchical menu with expand/collapse
 * - Collapsible sidebar
 * - Active state highlighting
 * - Fallback to static items
 */
export function Sidebar() {
  return <DynamicSidebar />;
}
